/* istanbul ignore file */
import _ from 'underscore';
import { BackboneSchema as backboneSchema } from '@bingads-webui/backbone-schema';
import { getHotelCenterService } from '@bingads-webui-campaign/hotel-center-service';

export const getHotelModel = ({
  i18n, hotelSchema, jsdata, edm, state,
}) => {
  if (!i18n || !hotelSchema || !state || !jsdata || !edm) {
    return {};
  }
  const SchemaModel = backboneSchema(hotelSchema, i18n, ['Id']);
  const { gridOptionUtils } = getHotelCenterService({ edm, state });
  /**
   * Hotel backbone model based on schema
   * @extends Backbone.Model
   */

  class HotelModel extends SchemaModel {
    initialize(options = {}) {
      this.set('Id', options.Id);
      this.entitySet = options.entitySet || gridOptionUtils.getEntitySetByName('hotel');
    }

    get idAttribute() {
      return 'Id';
    }

    toJSON() {
      const json = super.toJSON();

      this.attachNestedModels(json, ['Bid', 'BidMultipliers', 'Name']);

      return json;
    }

    sync(method, model, options) {
      const json = model.toJSON();

      switch (method) {
        case 'read':
          return jsdata.Hotel
            .find(this.get('Id'), {
              entitySet: this.entitySet,
            });
        case 'create':
          return jsdata.Hotel.create(json, {
            cacheResponse: false,
            entitySet: this.entitySet,
          });
        case 'patch':
        case 'update':
          if (_.has(json, 'Bid') && json.Bid.Amount === null) {
            json.Bid = null; // if user didn't input Bid amout, pass null object to odata
          }

          return jsdata.Hotel.update(
            model.get('Id'),
            _.isEmpty(options.attrs) ? json : _.pick(json, options.attrs),
            {
              cacheResponse: false,
              entitySet: this.entitySet,
            }
          );
        default:
          throw new Error(`sync method ${method} is not supported`);
      }
    }

    attachNestedModels(json, fieldNames) {
      _.each(fieldNames, (field) => {
        if (this.has(field) || _.contains(this.changedAttributes(), 'MaximumBid')) {
          json[field] = this.get(field); // eslint-disable-line
        }
      });
    }
  }

  return {
    HotelModel,
  };
};
